<div class="dropdown" [class.is-active]="isOpen" data-e2e="reportType-dropdownButton">
  <div class="dropdown-trigger">
    <button
      [attr.aria-expanded]="isOpen"
      class="button is-chip is-size-7-mobile"
      [class.is-applied]="getValues().length"
      [class.is-active]="isOpen"
      data-e2e="reportType-filterButton"
      (click)="itemToggled.emit()"
      type="button"
      title="{{ serviceProviderText }}"
    >
      <span data-e2e="reportType-filterButtonText">{{ serviceProviderText }}</span>
      <span class="icon">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
  </div>

  <div class="dropdown-menu is-large">
    <div class="dropdown-content">
      <div class="dropdown-item">
        <div
          class="is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-end"
        >
          <button
            class="button is-text has-text-link is-small mb-1"
            data-e2e="button-select-all-report-types"
            (click)="onSelectAllReports()"
            (keydown.enter)="onSelectAllReports()"
            type="button"
            title="Select All"
            i18n-title
            i18n
          >
            Select All
          </button>
        </div>
      </div>
      <div class="dropdown-item is-scrollable">
        <ng-container *ngFor="let reportType of reportTypeList">
          <portal-search-filter-checkbox
            [id]="reportType.id"
            [text]="reportType.text"
            [selectedEntities]="localPreSelectedEntities"
            (removed)="onEntityRemoved($event)"
            (added)="onEntityAdded($event)"
          ></portal-search-filter-checkbox>
        </ng-container>
      </div>

      <hr class="dropdown-divider" />
      <div class="dropdown-item is-flex is-justify-content-space-between">
        <button
          class="button is-outlined"
          data-e2e="button-clear-filter"
          i18n
          (click)="onClearFilter()"
          (keydown.enter)="onClearFilter()"
          type="button"
          title="Clear"
          i18n-title
        >
          Clear
        </button>
        <button
          class="button is-primary ml-2"
          data-e2e="button-filter"
          i18n
          (click)="onFilterApplied()"
          type="button"
          title="Apply"
          i18n-title
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
